/**
 * Nav and Tabs AREOI plugin block extension
 */

jQuery(document).ready(function ($) {
  $(".section-our-expertise__main .tab-panel:not(.tab-panel:first-of-type)").hide();

  $(".section-our-expertise__sidebar a").click(function (e) {
    e.preventDefault();

    var selector = $(this).attr("href");
    var parent = $(this).parents(".section-our-expertise");

    parent.find(".tab-panel").hide();
    parent.find(selector).show();
    parent.find(".section-our-expertise__sidebar a").removeClass("active");

    $(this).addClass("active");
  });
});

$('.nav-tabs-navigation').on('click', 'a', function () {
  let slider = $(this.getAttribute("href")).find('.wp-block-cb-carousel');
  slider.slick('refresh');
});